import React from "react";

// threshold

const TempleThreshholds = () => {
  return (
    <div>
      <div>
        zeus lang
        {/* top left corner */}
      </div>

      <div>
        {/* top right corner
        corresponding pillars using > state < with documents
        */}
        <div>
          docs
          {/* zeus lang docs
          
          zeus lang info 

          */}
        </div>
        <div>
          light
          {/* light documents
          
          outline :

          svms 
          
          */}
        </div>

        <div>
          temple grid
          {/* temple grid documents
          
          outline :

          file use and construct 
          */}
        </div>
      </div>
    </div>
  );
};

export default TempleThreshholds;
